import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';

import type { AlertsDefaultOptionsStateName } from '..';

type AlertsDefaultOptionsProps = {
  showAlert: {
    pix: boolean;
    card: boolean;
    boleto: boolean;
    multipleCards: boolean;
    eduzzBalance: boolean;
  };
  toggleAlert: (alertName: AlertsDefaultOptionsStateName) => void;
  onToggleConfirmed: (fieldId: string, checked: boolean) => void;
};

function AlertsDefaultOptions({ showAlert, toggleAlert, onToggleConfirmed }: AlertsDefaultOptionsProps) {
  const showAlertPix = showAlert.pix;
  const showAlertCard = showAlert.card;
  const showAlertBoleto = showAlert.boleto;
  const showAlertMultipleCards = showAlert.multipleCards;
  const showAlertEduzzBalance = showAlert.eduzzBalance;

  const toggleAlertPix = () => toggleAlert('showAlertPix');
  const toggleAlertCard = () => toggleAlert('showAlertCard');
  const toggleAlertBoleto = () => toggleAlert('showAlertBoleto');
  const toggleAlertMultipleCards = () => toggleAlert('showAlertMultipleCards');
  const toggleAlertEduzzBalance = () => toggleAlert('showAlertEduzzBalance');

  const handleToggleConfirmed = (fieldId: string, checked: boolean, callback: () => void) => {
    onToggleConfirmed(fieldId, checked);
    callback();
  };

  const dialogsList = [
    {
      id: 'pix',
      show: showAlertPix,
      fieldId: 'allows_pix',
      contentText: 'Desativar o pagamento via PIX pode reduzir suas vendas em até 47% e limitar o potencial de conversão do seu produto.',
      onCancel: toggleAlertPix,
      onConfirm: () => handleToggleConfirmed('allows_pix', false, toggleAlertPix),
    },
    {
      id: 'card',
      show: showAlertCard,
      fieldId: 'allows_card',
      contentText: 'Cartões concentram cerca de 89% das transações na Eduzz. Ignorar essa preferência pode comprometer seus resultados.',
      onCancel: toggleAlertCard,
      onConfirm: () => handleToggleConfirmed('allows_card', false, toggleAlertCard),
    },
    {
      id: 'boleto',
      show: showAlertBoleto,
      fieldId: 'allows_boleto',
      contentText: 'Um em cada três clientes escolhe pagar por boleto. Deixe essa opção disponível e potencialize o alcance do seu produto.',
      onCancel: toggleAlertBoleto,
      onConfirm: () => handleToggleConfirmed('allows_boleto', false, toggleAlertBoleto),
    },
    {
      id: 'multiple-card',
      show: showAlertMultipleCards,
      fieldId: 'allows_multiple_cards',
      contentText: 'Clientes querem flexibilidade. Com dois cartões na mesma compra, suas vendas podem crescer até 18%.',
      onCancel: toggleAlertMultipleCards,
      onConfirm: () => handleToggleConfirmed('allows_multiple_cards', false, toggleAlertMultipleCards),
    },
    {
      id: 'eduzz-balance',
      show: showAlertEduzzBalance,
      fieldId: 'allows_eduzz_balance',
      contentText: 'Ao desativar, seus compradores não poderão pagar com saldo Eduzz.',
      onCancel: toggleAlertEduzzBalance,
      onConfirm: () => handleToggleConfirmed('allows_eduzz_balance', false, toggleAlertEduzzBalance),
    },
  ];

  return (
    <>
      {dialogsList.map((dialog) => (
        <Dialog
          id={`alert-dialog-${dialog.id}`}
          key={dialog.id}
          open={dialog.show}
          onClose={dialog.onCancel}
          aria-labelledby={`alert-dialog-${dialog.id}-title`}
          aria-describedby={`alert-dialog-${dialog.id}-description`}
        >
          <DialogTitle id={`alert-dialog-${dialog.id}-title`}>Tem certeza que deseja desativar esta funcionalidade?</DialogTitle>
          <DialogContent>
            <DialogContentText id={`alert-dialog-${dialog.id}-description`}>{dialog.contentText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button id={`alert-dialog-${dialog.id}-btn-confirm`} onClick={dialog.onConfirm}>
              Desativar mesmo assim
            </Button>
            <Button id={`alert-dialog-${dialog.id}-btn-cancel`} onClick={dialog.onCancel} variant='contained' color='primary' autoFocus>
              Manter ativado
            </Button>
          </DialogActions>
        </Dialog>
      ))}
    </>
  );
}

export default AlertsDefaultOptions;
